export const VOLUME_CHANGE = 'VOLUME_CHANGE';

export function volumeChange(value) {
    return {type: VOLUME_CHANGE, value};
};


// WEBPACK FOOTER //
// ./src/actions/volume.js